// CameraFrameWithinAspectRatio.js
var CameraFrameWithinAspectRatio = pc.createScript('cameraFrameWithinAspectRatio');

CameraFrameWithinAspectRatio.attributes.add('leftWall', {type: 'entity'});
CameraFrameWithinAspectRatio.attributes.add('rightWall', {type: 'entity'});

CameraFrameWithinAspectRatio.prototype.initialize = function() {
    
    this.newCalculateRatio();
    this.entity.on("destroy", this.OnDestroy,this);
};


CameraFrameWithinAspectRatio.prototype.newCalculateRatio = function() {

    let leftValue = (6.375 / +(this.app.graphicsDevice.height / this.app.graphicsDevice.width)).toFixed(2);
    this.leftWall.rigidbody.teleport(new pc.Vec3(-leftValue, this.leftWall.getLocalPosition().z, this.leftWall.getLocalPosition().y));

    let rightValue = (6.375 / +(this.app.graphicsDevice.height / this.app.graphicsDevice.width)).toFixed(2);
    this.rightWall.rigidbody.teleport(new pc.Vec3(rightValue, this.rightWall.getLocalPosition().y, this.rightWall.getLocalPosition().z));

};

CameraFrameWithinAspectRatio.prototype.OnDestroy = function(){
    this.entity.off("destroy", this.OnDestroy,this);
};


